const INITIAL_STATE = {
  productsGroupingList: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_PRODUCTS_GROUPING': {
      return { ...state, productsGroupingList: action.productsGrouping };
    }
    default:
      return state;
  }
};
